export default __webpack_public_path__ + "static/media/connectedsecurenetwork.16346748.png";